import React from 'react';
import { RedocStandalone } from 'redoc';


const Docs = () => {
	const doc = {
		'openapi': '3.0.0',
		'info': {
			'title': 'FutureFunder Integration API',
			'description': 'RESTful API for use of third party commercial services that sell and resell vouchers.',
		  	'version': '0.0.1'
		},
		'servers': [{
		  	'url': 'https://europe-west2-futurefunder-5e4e4.cloudfunctions.net/',
			'description': 'FutureFunder production server'
		}],
		'paths': {
			'/vouchers': {
				'get': {
					'summary': 'Get project vouchers',
					'description': 'Returns a list of vouchers available to fund a project along with it\'s goals',
					'requestBody': {
						'required': true,
						'content': {
							'application/json': {
								'schema': {
									'type': 'object',
									'properties': {
										'projectId': {
											'type': 'string'
										},
										'userId': {
											'type': 'string'
										},
									}
								}
							}
						}
					},

				},
				'post': {
					'summary': 'Add vouchers to a project',
					'description': 'Link vouchers that are being sold on a 3rd party platform to a FutureFunder project',
					'requestBody': {
						'required': true,
						'content': {
							'application/json': {
								'schema': {
									'type': 'object',
									'properties': {
										'projectId': {
											'type': 'string'
										},
										'userId': {
											'type': 'string'
										},
										'voucher': {
											'type': 'object',
											'properties': {
												'originalPrice': {
													'type': 'number',
												},
												'additionalPrice': {
													'type': 'number',
												},
												'voucherPrice': {
													'type': 'number',
												},
												'name': {
													'type': 'string',
												},
												'source': {
													'type': 'string',
												},
												'description': {
													'type': 'string',
												},
											}
										}

									}
								}
							}
						}
					},
					'responses': {
						'200': {
							'description': 'Vouchers were added to the project',
							'content': {
								'application/json': {
									'schema': {
										'type': 'object',
										'properties': {
											'status': {
												'type': 'string',
												'example': 'OK'
											},
											'voucherId': {
												'type': 'string',
											}
										}
									}
								}
							}
						},
						'400': {
							'description': 'Wrong or invalid userId',
						},
						'404': {
							'description': 'projectId does not match to user',
						}
					}
				},
				'put': {
					'summary': 'Notify for a single voucher purchase',
					'description': 'Call this whenever a purchase has been completed on your platform. This will be used to update the status bar of the project',
					'requestBody': {
						'required': true,
						'content': {
							'application/json': {
								'schema': {
									'type': 'object',
									'properties': {
										'projectId': {
											'type': 'string'
										},
										'userId': {
											'type': 'string'
										},
										'customer': {
											'type': 'object',
											'properties': {
												'name': {
													'type': 'string'
												},
												'email': {
													'type': 'string'
												},
												'goalId': {
													'type': 'number'
												}
											}
										}
									}
								}
							}
						}
					},
					'responses': {
						'200': {
							'description': 'Project progress updated, customer added as a contributor to the goal',
							'content': {
								'application/json': {
									'schema': {
										'type': 'object',
										'properties': {
											'status': {
												'type': 'string',
												'example': 'OK'
											},
											'customerId': {
												'type': 'string',
											}
										}
									}
								}
							}
						},
						'400': {
							'description': 'Wrong or invalid userId',
						},
						'404': {
							'description': 'projectId does not match to user',
						}
					}
				}
			}
		}
	};
	return (
		<div className="docs">
	        <RedocStandalone spec={doc} />
		</div>
	);
};

export default Docs;
